export const DIRECT_CONTACT_FORM_ORDERS_PER_REQUEST = 20
